import React, { FC } from 'react';
import PrimaryNavigation from '../../components/core/PrimaryNavigation/PrimaryNavigation';
import ProfileNotContent from '../../components/ProfilenoContent/ProfileNoContent';




interface MeRepositorysProps {}

const MeRepositorys: FC<MeRepositorysProps> = () => (
  <div className="ErrorPage">
  <PrimaryNavigation />
  <div className="container-ErrorPage">
 <ProfileNotContent></ProfileNotContent>
  </div>
</div>
);

export default MeRepositorys;